import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { supabase } from '../../../lib/supabase';

const UserManagementTable = ({ users, onRefresh }) => {
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleToggleUserStatus = async (userId, currentStatus) => {
    try {
      setLoading(true);
      const { error } = await supabase
        ?.from('user_profiles')
        ?.update({ is_active: !currentStatus })
        ?.eq('id', userId);

      if (error) throw error;
      
      alert(`User ${!currentStatus ? 'activated' : 'deactivated'} successfully`);
      onRefresh?.();
    } catch (err) {
      console.error('Error updating user status:', err);
      alert('Failed to update user status');
    } finally {
      setLoading(false);
    }
  };

  const handleViewProfile = (userId) => {
    window.open(`/user-profile?userId=${userId}`, '_blank');
  };

  return (
    <div className="bg-card rounded-lg shadow-md border border-border overflow-hidden">
      <div className="p-6 border-b border-border">
        <h2 className="text-xl font-semibold text-foreground flex items-center gap-2">
          <Icon name="Users" size={24} />
          User Management
        </h2>
        <p className="text-sm text-muted-foreground mt-1">
          Manage user accounts, verify profiles, and moderate user activity
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                User
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Email
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Role
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Joined
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {users?.map((user) => (
              <tr key={user?.id} className="hover:bg-muted/30 transition-smooth">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center gap-3">
                    <img
                      src={user?.avatar_url || 'https://img.rocket.new/generatedImages/rocket_gen_img_1e6008c7e-1768740999976.png'}
                      alt={`${user?.full_name} avatar`}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <p className="font-medium text-foreground text-sm">{user?.full_name}</p>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <p className="text-sm text-muted-foreground">{user?.email}</p>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary capitalize">
                    {user?.role || 'both'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                    user?.is_active ? 'bg-success/10 text-success' : 'bg-destructive/10 text-destructive'
                  }`}>
                    {user?.is_active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <p className="text-sm text-muted-foreground">
                    {new Date(user?.created_at)?.toLocaleDateString()}
                  </p>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => handleViewProfile(user?.id)}
                      className="p-2 hover:bg-primary/10 rounded-lg transition-smooth"
                      title="View Profile"
                    >
                      <Icon name="Eye" size={16} className="text-primary" />
                    </button>
                    <button
                      onClick={() => handleToggleUserStatus(user?.id, user?.is_active)}
                      disabled={loading}
                      className="p-2 hover:bg-warning/10 rounded-lg transition-smooth disabled:opacity-50"
                      title={user?.is_active ? 'Deactivate User' : 'Activate User'}
                    >
                      <Icon name={user?.is_active ? 'UserX' : 'UserCheck'} size={16} className="text-warning" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {users?.length === 0 && (
        <div className="p-12 text-center">
          <Icon name="Users" size={48} className="mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No users found</p>
        </div>
      )}
    </div>
  );
};

export default UserManagementTable;